<template>
    <div class="qingwu">
        <div class="admin_main_block">
            <div class="admin_main_block_top">
                <div class="admin_main_block_left">
                    <div><el-button icon="el-icon-search" @click="exports()">导出表格</el-button></div>
                    <div><el-input v-model="where.shangj" placeholder="请输入商家名称"></el-input></div>
                    <div><el-date-picker format="yyyy-MM-dd HH:mm" v-model="where.times" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker></div>

                    <div><el-button icon="el-icon-search" @click="get_adv_list()">条件筛选</el-button></div>
                </div>

<!--                <div class="admin_main_block_right">
                    <div><el-button type="danger" icon="el-icon-delete" @click="del(select_id)">批量删除</el-button></div>
                </div>-->
            </div>
            <div class="admin_table_main">
                <el-table :data="list" @selection-change="handleSelectionChange" >
                    <el-table-column type="selection"></el-table-column>
                    <!-- <el-table-column prop="id" label="#" fixed="left" width="70px"></el-table-column> -->
                    <el-table-column prop="id" label="#"  width="70px"></el-table-column>

                  <el-table-column label="商品名称" width="280px">
                    <template slot-scope="scope">
                      <dl class="table_dl">
                        <dt><el-image style="width: 50px; height: 50px" :src="scope.row.goodsimg"><div slot="error" class="image-slot"><i class="el-icon-picture-outline"></i></div></el-image></dt>
                        <dd class="table_dl_dd_all">{{ scope.row.goodsname }}</dd>
                      </dl>
                    </template>
                  </el-table-column>
                  <el-table-column prop="shangj" label="商家"  width=""></el-table-column>
                  <el-table-column prop="hes" label="盒数"  width="45px"></el-table-column>
                  <el-table-column prop="tihbm" label="提货编码"  width=""></el-table-column>
                  <el-table-column prop="kam" label="卡密"  width="65px"></el-table-column>
                  <el-table-column prop="xingm" label="用户姓名"  width="75px"></el-table-column>
                  <el-table-column prop="shouj" label="用户手机号"  width="85px"></el-table-column>
                  <el-table-column prop="xiangxdz" label="详细地址"  width=""></el-table-column>


                    <!--<el-table-column prop="F_VR_MENDDZ" label="门店地址" width="170px"></el-table-column>-->
                    <el-table-column prop="adv_start" label="创建时间"  width="120px">
                        <template slot-scope="scope">
                            <div v-if="scope.row.chuangjsj<=0"> - </div>
                            <div v-else>{{scope.row.chuangjsj|formatDate}}</div>
                        </template>
                    </el-table-column>



                    <el-table-column prop="kuaidf" label="快递方式"></el-table-column>
                    <el-table-column prop="danh" label="快递单号"></el-table-column>
                   <!-- <el-table-column label="操作" fixed="right" width="120px">
                        <template slot-scope="scope">
                            <el-button icon="el-icon-edit" @click="$router.push({name:'adv_form',params:{id:scope.row.id}})">编辑</el-button>
                            &lt;!&ndash; <el-button type="danger" icon="el-icon-delete" @click="del(scope.row.id)">删除</el-button> &ndash;&gt;
                        </template>
                    </el-table-column>-->

                    <el-table-column label="操作" fixed="right" width="240px">
                        <template slot-scope="scope">
                            <el-button icon="el-icon-bank-card" @click="change_user_money(scope.row.id)">快递单号</el-button>
                            <!-- <el-button type="danger" icon="el-icon-delete" @click="del(scope.row.id)">删除</el-button> -->
                        </template>
                    </el-table-column>
                    <div slot="append">
                        <div class='sum_footer xiaoji' ref='sum_xiaoji'>
                            <div class='sum_footer_unit'></div>
                            <div class='sum_footer_unit'></div>
                            <div class='sum_footer_unit'></div>
                            <div class='sum_footer_unit center' ><!--总金额：{{zongje}}--></div>
                            <div class='sum_footer_unit center' >订单数：{{dingds}}</div>
                            <div class='sum_footer_unit'></div>
                            <div class='sum_footer_unit'></div>
                            <div class='sum_footer_unit'></div>
                            <div class='sum_footer_unit'></div>
                        </div>
                    </div>
                </el-table>
                <div class="admin_table_main_pagination">
                    <el-pagination @current-change="current_change" background layout="prev, pager, next,jumper,total" :total="total_data" :page-size="page_size" :current-page="current_page"></el-pagination>
                </div>
            </div>
        </div>




        <!-- 调整资金弹出框 -->
        <el-dialog title="快递单号" :visible.sync="changeShow" width="30%">
            <el-form ref="form"  label-width="90px">
                <el-form-item label="快递方：">
                    <el-input v-model="change_info.kuaidf"></el-input>
                </el-form-item>
                <el-form-item label="快递单号：">
                    <el-input v-model="change_info.danh"></el-input>
                </el-form-item>
            </el-form>


            <span slot="footer" class="dialog-footer">
                <el-button @click="changeShow = false">取 消</el-button>
                <el-button type="primary" @click="change_start()">确 定</el-button>
            </span>
        </el-dialog>





    </div>
</template>

<script>
export default {
    components: {},
    props: {},
    data() {
      return {
          list:[],
          total_data:0, // 总条数
          page_size:20,
          current_page:1,
          select_id:'',
          adv_position_id:0,
          where:{
              shangj:'',
              times:[],
          },
          zongje:0,
          dingds:0,
          changeShow:false, // 显示调整输入框
          change_info:{
              kuaidf:'',
              danh:'',
          },
          dingd_id:0


      };
    },
    watch: {},
    computed: {},
    methods: {
        change_user_money:function(id){
            this.dingd_id = id;
            this.changeShow = true;
        },
        change_start:function(){
            this.change_info.dingd_id = this.dingd_id;
            this.$post(this.$api.adminChangeKamdd,this.change_info).then(res=>{
                if(res.code == 200){
                    this.changeShow = false;
                    this.$message.success('修改成功');
                    this.get_adv_list();
                }else{
                    this.$message.error(res.msg);
                }
            });
        },
        handleSelectionChange:function(e){
            let ids = [];
            e.forEach(v => {
                ids.push(v.F_IN_ID);
            });
            this.select_id = ids.join(',');
        },
        get_adv_list:function(){
            let where = {};
            where.page = this.current_page;
            where.params = this.where;
            this.$get(this.$api.getKamlsddList,where).then(res=>{
              console.log(res.data)
                this.page_size = res.data.info.per_page;
                this.total_data = res.data.info.total;
                this.current_page = res.data.info.current_page;
                this.list = res.data.info.data;
                this.dingds = res.data.dingds;
            })

        },
      exports: function () {
        if (this.where.times[0]) {
          this.where.times[0] = this.where.times[0].toGMTString();
          this.where.times[1] = this.where.times[1].toGMTString();
        }
        window.open(`https://apiapple.jizhikaifa.com/api/excel/orderkamdd?shangj=${this.where.shangj}&timeone=${this.where.times[0]}&timetwo=${this.where.times[1]}`, '_self');
      },
        // 删除处理
        del:function(F_IN_ID){
            if(this.$isEmpty(F_IN_ID)){
                return this.$message.error('请先选择删除的对象');
            }
            this.$post(this.$api.delKamdd,{F_IN_ID:F_IN_ID}).then(res=>{
                if(res.code == 200){
                    this.get_adv_list();
                    return this.$message.success("删除成功");
                }else{
                    return this.$message.error("删除失败");
                }
            });
        },
        current_change:function(e){
            this.current_page = e;
            this.get_adv_list();
        },
    },
    created() {
        this.get_adv_list();
    },
    mounted() {}
};
</script>
<style lang="scss" scoped>
    .table_dl_dd_all{
        height: 50px;
        overflow: hidden;
    }
    .sum_footer{
        display:flex;
        display:-webkit-flex;
        line-height:50px;
        color:#606266;
    }
    .sum_footer_unit{
        flex-grow:1;
        -webkit-flex-grow:1;
        text-indent:10px;
        font-size:14px;
        font-weight:bold;
    }
    .sum_footer_unit.center{
        text-align:center;
    }
    .sum_footer.xiaoji{
        border-bottom:1px solid #EBEEF5;
    }

    .admin_main_block_left div {
        float: left;
        margin-right: 2px;
    }

    .el-range-editor--small .el-range-input {
        font-size: 13px;
        width: 120px;
    }
</style>
